import * as React from 'react';

import SVGBase from '../svg-base/svg-base';

export interface NewReleaseNoDataProps {
    fill?: string;
    title?: string;
    height?: string;
    width?: string;
    viewBox?: string;
}

const NewReleaseNoData: React.FunctionComponent<NewReleaseNoDataProps> = ({
    fill,
    title,
    height,
    width,
    ...rest
}: NewReleaseNoDataProps) => (
    <SVGBase viewBox="0 0 185.45 155.82" height={height} width={width} title={title} fill={fill} {...rest}>
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <rect fill="#b9eafc" x="0.49" y="11.9" width="184.48" height="115.73" rx="3.89" />
                <g opacity="0.7">
                    <path fill="#fff" d="M185,30.47H.49a.49.49,0,1,1,0-1H185a.49.49,0,0,1,0,1Z" />
                </g>
                <circle fill="#fff" cx="10.06" cy="21.45" r="2.65" />
                <circle fill="#fff" cx="29.59" cy="21.45" r="2.65" />
                <circle fill="#fff" cx="19.83" cy="21.45" r="2.65" />
                <path
                    fill="#4e5ef2"
                    d="M83.72,99.89h58.76a0,0,0,0,1,0,0v49.88a0,0,0,0,1,0,0H83.77a2.52,2.52,0,0,1-2.52-2.52V102.36a2.48,2.48,0,0,1,2.48-2.48Z"
                    transform="translate(-26.55 30.29) rotate(-13.8)"
                />
                <path
                    fill="#004abc"
                    d="M140,90h22.17a2.48,2.48,0,0,1,2.48,2.48v44.88a2.52,2.52,0,0,1-2.52,2.52H140a0,0,0,0,1,0,0V90a0,0,0,0,1,0,0Z"
                    transform="translate(-23.01 39.65) rotate(-13.8)"
                />
                <rect
                    fill="#00b1ff"
                    x="110.48"
                    y="99.92"
                    width="2.47"
                    height="49.88"
                    transform="translate(-26.56 30.25) rotate(-13.8)"
                />
                <rect
                    fill="#00b1ff"
                    x="152.31"
                    y="89.65"
                    width="2.47"
                    height="49.88"
                    transform="translate(-22.9 39.94) rotate(-13.8)"
                />
                <g mix-blend-mode="overlay">
                    <path
                        fill="#031c44"
                        d="M169.59,133.61,158.94,90.25a2.49,2.49,0,0,0-2.92-2l-20,4.9,32.85,43A2.7,2.7,0,0,0,169.59,133.61Z"
                    />
                </g>
                <circle fill="#ff337d" cx="83.91" cy="43.49" r="19.96" />
                <path
                    fill="#fff"
                    d="M95.82,45.33a1.64,1.64,0,0,1,.74,1,1.6,1.6,0,0,1-.14,1.23,1.54,1.54,0,0,1-1,.78L76.61,53.55a1.61,1.61,0,0,1-.87,0,1.52,1.52,0,0,1-.72-.43,1.62,1.62,0,0,1-.27-1.91,2.21,2.21,0,0,0,.09-.24,11.14,11.14,0,0,0,.78-1.64,8.74,8.74,0,0,0,.28-2.48,13.93,13.93,0,0,0-.57-3.94,7.77,7.77,0,0,1,.38-5.44,8,8,0,0,1,3.77-3.91l-.29-1a1.55,1.55,0,0,1,.16-1.24,1.59,1.59,0,0,1,1-.77,1.67,1.67,0,0,1,2,1.13l.28,1A8,8,0,0,1,91,38.54a13.76,13.76,0,0,0,1.55,3.66,8.54,8.54,0,0,0,1.53,2,10.83,10.83,0,0,0,1.52,1A1.27,1.27,0,0,0,95.82,45.33ZM89.29,54.1a3.25,3.25,0,0,1-4.41,1.24,3.15,3.15,0,0,1-1.56-2l6.27-1.76A3.1,3.1,0,0,1,89.29,54.1Z"
                />
                <circle fill="#ff337d" cx="125.98" cy="73.58" r="13.44" />
                <path
                    fill="#fff"
                    d="M132.55,78.33a1.1,1.1,0,0,1-.3,1.49,1,1,0,0,1-.84.16l-12.89-2.61a1.09,1.09,0,0,1-.83-.74,1.14,1.14,0,0,1,0-.55,1,1,0,0,1,.45-.67l.13-.12a8.28,8.28,0,0,0,1-.75,6.06,6.06,0,0,0,.93-1.4,9.49,9.49,0,0,0,.86-2.53,5.22,5.22,0,0,1,1.9-3.15,5.29,5.29,0,0,1,3.45-1.18l.14-.71a1.06,1.06,0,0,1,.48-.69,1.08,1.08,0,0,1,.82-.17,1.06,1.06,0,0,1,.69.48,1,1,0,0,1,.16.82l-.14.7a5.29,5.29,0,0,1,3.17,3.58,5.23,5.23,0,0,1,.07,2.49,9.37,9.37,0,0,0-.19,2.67,6.13,6.13,0,0,0,.31,1.66,7.88,7.88,0,0,0,.61,1.06A.89.89,0,0,0,132.55,78.33ZM126,81.59a2.16,2.16,0,0,1-1.64.31,2.19,2.19,0,0,1-1.71-2.58l4.3.87A2.1,2.1,0,0,1,126,81.59Z"
                />
                <path fill="#4e5ef2" d="M153.54,42.92,101.78,12a2,2,0,0,1-.43-2.82l4-6.65,53.32,31.82Z" />
                <path
                    fill="#004abc"
                    d="M171.3,53.51l-19.6-11.7,5.07-8.54L177.94,45.9,174,52.54A2,2,0,0,1,171.3,53.51Z"
                />
                <polygon fill="#00b1ff" points="127.44 27.34 125.33 26.08 130.4 17.54 132.52 18.8 127.44 27.34" />
                <polygon fill="#00b1ff" points="164.54 49.48 162.22 48.1 167.3 39.56 169.61 40.94 164.54 49.48" />
                <path
                    fill="#00b1ff"
                    d="M132.61,18.55a1.2,1.2,0,0,1-.37.15,1.34,1.34,0,0,1-1-.15l-8.33-4.93a6.79,6.79,0,0,1-3.4-6.07,6.51,6.51,0,0,1,2.2-4.68,6.79,6.79,0,0,1,5.05-1.7,7.47,7.47,0,0,1,5,2.53c1.51,1.74,1.69,4,1.67,6.06,0,1.18,0,2.37-.06,3.55,0,1.36-.06,2.72-.07,4.09A1.34,1.34,0,0,1,132.61,18.55ZM124.14,4.41a4.78,4.78,0,0,0-.64.47,3.87,3.87,0,0,0-1.3,2.77,4.09,4.09,0,0,0,2.08,3.65l6.33,3.75c0-.6,0-1.2,0-1.8,0-1.17,0-2.34.06-3.52,0-1.59-.09-3.21-1-4.27a4.81,4.81,0,0,0-3.16-1.61A4.19,4.19,0,0,0,124.14,4.41Z"
                />
                <path
                    fill="#00b1ff"
                    d="M146.19,23.44a6.8,6.8,0,0,1-6.95-.1l-8.3-5a1.34,1.34,0,0,1-.66-1.18A1.39,1.39,0,0,1,131,16c1.19-.65,2.36-1.32,3.54-2,1-.6,2.07-1.19,3.11-1.76,1.77-1,3.88-1.92,6.13-1.42A7.42,7.42,0,0,1,148.35,14a6.79,6.79,0,0,1,.91,5.24,6.53,6.53,0,0,1-3.06,4.17Zm-11.88-6.19L140.62,21a4.13,4.13,0,0,0,4.21.09h0a3.84,3.84,0,0,0,1.81-2.46,4.08,4.08,0,0,0-.55-3.16,4.78,4.78,0,0,0-2.91-2c-1.37-.31-2.85.37-4.24,1.14-1,.57-2.06,1.16-3.08,1.74Z"
                />
                <rect
                    fill="#00b1ff"
                    x="140.69"
                    y="-20.14"
                    width="2.69"
                    height="87.2"
                    transform="translate(49.23 133.51) rotate(-59.23)"
                />
                <path
                    fill="#7481f5"
                    d="M58.52,76.17a1.76,1.76,0,0,1,3.06.8l1.6,7.87L70.58,88a1.53,1.53,0,0,1,1.08,1.46,1.67,1.67,0,0,1-.88,1.63l-7,4-.7,8A1.62,1.62,0,0,1,62,104.56a1.59,1.59,0,0,1-1.77-.33l-6-5.4-7.85,1.78a1.52,1.52,0,0,1-1.72-.56,1.67,1.67,0,0,1-.25-1.82l3.34-7.35L43.56,84a1.68,1.68,0,0,1,0-1.86,1.52,1.52,0,0,1,1.66-.74l8,.86Z"
                />
                <path
                    fill="#7481f5"
                    d="M34,44.76a1.15,1.15,0,0,1,1.75-1.08l4.43,2.77L45,44.39a1,1,0,0,1,1.18.15,1.07,1.07,0,0,1,.37,1.14l-1.27,5.1,3.48,3.95A1,1,0,0,1,49,55.89a1,1,0,0,1-1,.69l-5.23.4-2.69,4.5a1,1,0,0,1-1,.56,1.08,1.08,0,0,1-1-.69l-2-4.88L31,55.33a1.07,1.07,0,0,1-.85-.84,1,1,0,0,1,.39-1.12l4-3.4Z"
                />
                <circle fill="#ff337d" cx="165.92" cy="65.47" r="5.25" />
            </g>
        </g>
    </SVGBase>
);

export default NewReleaseNoData;
